<template>
    <vue-final-modal
        @opened="opened"
        v-bind="$attrs"
        v-slot="{ close }"
        :esc-to-close="true"
        v-if="workflow.triggers && workflow.triggers.length && workflow.triggers[0]"
    >
        <div class="opui-modal opui-modal-worflow-trigger-edit" @click="$events.emit('clickedOutside')">
            <div class="opui-modal-dialog opui-mw-900">
                <div class="opui-modal-content">
                    <div class="opui-modal-header">
                        <h1>
                            {{ $e('Trigger Event') }}
                        </h1>
                        <i @click.prevent="close" class="opui-icon-close opui-modal-close"></i>
                    </div>

                    <div class="opui-modal-body">
                        <form class="opui-form" @submit.prevent="save" method="post">
                            <div class="opui-row">
                                <div class="opui-col">
                                    <RichSelect
                                        v-model="workflow.triggers[0].event"
                                        modelValue="workflow.triggers[0].event"
                                        :options="triggerGroups"
                                        :placeholder="'Choose a trigger event'"
                                        @select="triggerChange"
                                        :required="true"
                                    />
                                </div>
                            </div>

                            <div class="opui-row" v-if="workflow.triggers[0].event">
                                <div class="opui-col">
                                    <ContactTrigger        :workflow="workflow" :trigger="workflow.triggers[0]" v-if="workflow.triggers[0].event === 'trigger/builder/contact/submit'" />
                                    <DateTimeTrigger       :workflow="workflow" :trigger="workflow.triggers[0]" v-if="workflow.triggers[0].event === 'trigger/general/datetime'" />
                                    <MembershipTrigger     :workflow="workflow" :trigger="workflow.triggers[0]" v-if="workflow.triggers[0].event === 'trigger/mentor/membership/add' || workflow.triggers[0].event === 'trigger/mentor/membership/remove'" />
                                    <FunnelTrigger         :workflow="workflow" :trigger="workflow.triggers[0]" v-if="workflow.triggers[0].event === 'trigger/funnels/optin'" />
                                    <OptinTrigger          :workflow="workflow" :trigger="workflow.triggers[0]" v-if="workflow.triggers[0].event === 'trigger/builder/optin/submit'" />
                                    <RUATrigger            :workflow="workflow" :trigger="workflow.triggers[0]" v-if="workflow.triggers[0].event === 'trigger/rua/membership/add' || workflow.triggers[0].event === 'trigger/rua/membership/remove'" />
                                    <SignupTrigger         :workflow="workflow" :trigger="workflow.triggers[0]" v-if="workflow.triggers[0].event === 'trigger/builder/register/submit'" />
                                    <WebhookTrigger        :workflow="workflow" :trigger="workflow.triggers[0]" v-if="workflow.triggers[0].event === 'trigger/general/webhook'" />
                                    <WishlistTrigger       :workflow="workflow" :trigger="workflow.triggers[0]" v-if="workflow.triggers[0].event === 'trigger/wishlist/membership/add' || workflow.triggers[0].event === 'trigger/wishlist/membership/remove'" />
                                    <WordPressPostTrigger  :workflow="workflow" :trigger="workflow.triggers[0]" v-if="workflow.triggers[0].event === 'trigger/wordpress/post/published' || workflow.triggers[0].event === 'trigger/wordpress/post/updated' || workflow.triggers[0].event === 'trigger/wordpress/post/comment'" />
                                </div>
                            </div>
                            <!-- <p><small>{{ workflow.triggers[0] }}</small></p> -->

                            <div class="opui-form-actions opui-justify-content-between opui-flex">
                                <button type="button" class="opui-btn opui-btn-outline-secondary opui-px-6" @click.prevent="closeAllModals">{{ $e('Cancel') }}</button>

                                <button type="submit" class="opui-btn opui-btn-primary" :class="{ saving: saving, disabled: saving, 'opui-disabled': ! canBeSaved }" :disabled="saving">
                                    <span class="opui-spinner opui-spinner-border opui-text-light opui-mr-2"></span>
                                    <span class="opui-btn-saving-label">{{ $e('Saving...') }}</span>
                                    <span class="opui-btn-label">{{ $e('Save Trigger') }}</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </vue-final-modal>
</template>

<script>
import ContactTrigger from "../Triggers/ContactTrigger.vue"
import DateTimeTrigger from "../Triggers/DateTimeTrigger.vue"
import FunnelTrigger from "../Triggers/FunnelTrigger.vue"
import OptinTrigger from "../Triggers/OptinTrigger.vue"
import RichSelect from "../../Global/RichSelect.vue"
import RUATrigger from "../Triggers/RUATrigger.vue"
import MembershipTrigger from "../Triggers/MembershipTrigger.vue"
import SignupTrigger from "../Triggers/SignupTrigger.vue"
import WebhookTrigger from "../Triggers/WebhookTrigger.vue"
import WishlistTrigger from "../Triggers/WishlistTrigger.vue"
import WordPressPostTrigger from "../Triggers/WordPressPostTrigger.vue"

export default {
    components: {
        ContactTrigger, DateTimeTrigger, FunnelTrigger, OptinTrigger, RichSelect,
        MembershipTrigger, RUATrigger, SignupTrigger, WebhookTrigger,
        WishlistTrigger, WordPressPostTrigger
    },
    props: {
        workflow: { type: Object, required: true },
    },
    data() {
        return {
            saving: false
        }
    },
    computed: {
        canBeSaved() {
            return !! this.workflow.triggers[0].event
        },

        /**
         * Create trigger groups for dropdown
         * @returns {*[]}
         */
        triggerGroups() {
            let groups = []

            Object.entries(window.OptimizeFlow.config.trigger_groups).forEach(entry => {
                const [key, item] = entry;

                if (window.OptimizeFlow.config.trigger_groups) {
                    const group = { id: key, text: item.title, active: item.active, children: [] }

                    if (item.active && item.triggers) {
                        Object.entries(item.triggers).forEach(triggerEntry => {
                            const [triggerKey, triggerItem] = triggerEntry;

                            if (triggerItem.active) {
                                group.children.push({id: triggerKey, text: triggerItem.title})
                            }
                        })
                    }

                    if (group.active) {
                        groups.push(group)
                    }
                }
            })

            return groups
        }
    },
    mounted() {
        if (this.workflow.triggers && this.workflow.triggers[0] && ! this.workflow.triggers[0].settings) {
            this.workflow.triggers[0].settings = {
                "post_type":      "page", "post_type_title":  "Pages",
                "page_id":        "all",  "page_title":        "- All -",
                "form_id":        "all",  "form_title":        "- All -",
                "membership_id":  "all",  "membership_title":  "- All -",
                "funnel_id":      "all",  "funnel_title":      "- All -",
                "funnel_step_id": "all",  "funnel_step_title": "- All -",
            }
        }
    },
    methods: {
        /**
         * Update the selected text
         */
        triggerChange(selected) {
            this.workflow.triggers[0].title = selected.text

            // We also need to save the trigger if not saved
            if (this.workflow.triggers[0] || this.workflow.triggers[0].id) {
                this.save(false)
            };
        },

        /**
         * Add new trigger item
         */
        async save(close = true) {
            // Set ID if needed
            this.$emit('updated', this.workflow)

            // And reset/close modal
            // this.trigger.event = null
            if (close) this.closeAllModals()
        },
    }
}
</script>

<style scoped>
.opui-modal-backdrop {
    opacity: .5;
}
</style>
